// extracted by mini-css-extract-plugin
export default {"collapsibleLabel":"shared-card-module__collapsibleLabel___wuV8Q","isDiscord":"shared-card-module__isDiscord___HSkef","caret":"shared-card-module__caret___Jg94z"};